import React from 'react';
import AppConfirmDialog from '@/ui/components/AppConfirmDialog';

type Props = {
  selectedCount: number;
  submitting?: boolean;
  error?: string;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
};

export default function PipelineBulkDeleteModal({
  selectedCount,
  submitting = false,
  error,
  onClose,
  onConfirm,
}: Props) {
  return (
    <AppConfirmDialog
      title="Delete selected executions?"
      lead={
        <>
          Permanently delete <strong>{selectedCount}</strong> selected pipeline execution record(s) and their linked
          activity log entries. This cannot be undone.
        </>
      }
      confirmLabel="Delete selected"
      submitting={submitting}
      error={error}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
}
